import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'
// import { deviceLayout } from 'styles/breakpoint'

export const StyledSearchArea = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 400px;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;

  & > :not(:first-of-type) {
    z-index: 9;
  }
`

export const StyledCustomBackground = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;

  ${MediaQueries.mbUp} {
    height: 350px;
  }

  ${MediaQueries.mbDown} {
    height: 250px;
  }

  background-image: url('${assetImagePath}/categoriesBackground.svg');
  background-position: 50% bottom;
  background-repeat: no-repeat;
  background-size: cover;
`

export const StyledContentContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;

  #categories-search {
    background-color: ${theme.colors.white};
    min-width: 100%;
    box-shadow: 0px 0px 25px rgba(38, 38, 38, 0.08);
    ${MediaQueries.mbUp} {
      width: 568px;
    }
  }
`

export const StyledCategoriesContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 16px;

  ${MediaQueries.mbDown} {
    padding: 0 12px;
  }

  &[data-layout-type='long'] {
    padding-top: 8px;
  }
`

export const StyledCategoryWrapper = styled.div`
  display: flex;
  width: 33.33%;
  height: auto;
  justify-content: center;
  padding: 0 4px;
  margin-top: 16px;

  &[data-layout-type='long'] .content {
    text-align: left;
  }

  ${MediaQueries.mbUp} {
    margin-top: 32px;
    width: 16.66%;
    padding: 0 16px;
  }

  & > a {
    width: 100%;
    height: 133px;
    .banner {
      margin-bottom: 8px;
    }

    ${MediaQueries.mbUp} {
      height: 150px;
      padding: 16px;
      .banner {
        width: auto;
      }

      .content > p[data-size='sm'] {
        font-size: ${theme.sizes.fsHeading6};
        line-height: 22px;
      }
    }
  }

  &[data-layout-type='long'] {
    width: 100%;
    margin-top: 8px;

    ${MediaQueries.mbUp} {
      width: 33.33%;
      margin-top: 32px;
    }

    & > a {
      display: flex;
      height: auto;
      flex-direction: row;

      .banner {
        width: auto;
        height: auto;
        padding: 0 8px;
        margin-bottom: 0;

        ${MediaQueries.mbUp} {
          margin-right: 16px;
        }
      }
    }
  }
`
